const namePattern = /^[a-zA-Z\s'-]+$/;
const SUPERSCRIPTPATTER = /SUP\{.*\}/;
export const patterns = {namePattern , SUPERSCRIPTPATTER};